import React, { useState } from "react";
import { Mail, Phone, MapPin, Send } from "lucide-react";
import { Reveal } from "../Reveal";

function Contact() {
  const [state, setState] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState("idle");

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus("sending");
    const subject = encodeURIComponent(`[Phuc Pham] Project inquiry from ${state.name || "Website"}`);
    const body = encodeURIComponent(`${state.message}\n\n— ${state.name} (${state.email})`);
    window.location.href = `mailto:tphuc.work@gmail.com?subject=${subject}&body=${body}`;
    setStatus("sent");
  };

  return (
    <section id="contact" className="section relative bg-levi-surface border-t border-levi-border">
      <div className="container-xl grid lg:grid-cols-12 gap-12">
        <Reveal className="lg:col-span-5">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-12 bg-levi-primary" />
            <span className="eyebrow">Contact</span>
          </div>
          <h2 className="display-lg text-levi-text mb-6">
            Reach the <br />
            <span className="text-levi-primary">studio.</span>
          </h2>
          <p className="text-lg text-levi-muted mb-12 max-w-md">
            For project enquiries, collaborations, or a simple hello — the fastest path
            is email. We reply within two working days.
          </p>

          <div className="space-y-6">
            <a href="mailto:tphuc.work@gmail.com" className="flex items-start gap-4 group">
              <div className="p-3 border border-levi-border group-hover:border-levi-primary transition-colors">
                <Mail size={18} className="text-levi-primary" />
              </div>
              <div>
                <div className="eyebrow mb-1">Email</div>
                <div className="text-levi-text group-hover:text-levi-primary transition-colors">
                  tphuc.work@gmail.com
                </div>
              </div>
            </a>

            <a href="tel:+84367183161" className="flex items-start gap-4 group">
              <div className="p-3 border border-levi-border group-hover:border-levi-primary transition-colors">
                <Phone size={18} className="text-levi-primary" />
              </div>
              <div>
                <div className="eyebrow mb-1">Phone</div>
                <div className="text-levi-text group-hover:text-levi-primary transition-colors">
                  +84 367 183 161
                </div>
              </div>
            </a>

            <div className="flex items-start gap-4">
              <div className="p-3 border border-levi-border">
                <MapPin size={18} className="text-levi-primary" />
              </div>
              <div>
                <div className="eyebrow mb-1">Studio</div>
                <div className="text-levi-text">Vietnam · Remote-first</div>
              </div>
            </div>
          </div>
        </Reveal>

        <Reveal className="lg:col-span-7" delay={0.15}>
          <form onSubmit={handleSubmit} className="p-8 md:p-10 bg-levi-bg border border-levi-border">
            <div className="grid md:grid-cols-2 gap-6">
              <label className="flex flex-col">
                <span className="eyebrow mb-2">Name</span>
                <input
                  type="text"
                  required
                  value={state.name}
                  onChange={(e) => setState({ ...state, name: e.target.value })}
                  placeholder="Your name"
                  className="bg-transparent border-b border-levi-border focus:border-levi-primary py-3 text-levi-text placeholder:text-levi-subtle outline-none transition-colors"
                />
              </label>
              <label className="flex flex-col">
                <span className="eyebrow mb-2">Email</span>
                <input
                  type="email"
                  required
                  value={state.email}
                  onChange={(e) => setState({ ...state, email: e.target.value })}
                  placeholder="you@company.com"
                  className="bg-transparent border-b border-levi-border focus:border-levi-primary py-3 text-levi-text placeholder:text-levi-subtle outline-none transition-colors"
                />
              </label>
            </div>

            <label className="flex flex-col mt-8">
              <span className="eyebrow mb-2">Message</span>
              <textarea
                required
                rows={5}
                value={state.message}
                onChange={(e) => setState({ ...state, message: e.target.value })}
                placeholder="Tell us about your product, timeline, and what 'good' looks like."
                className="bg-transparent border-b border-levi-border focus:border-levi-primary py-3 text-levi-text placeholder:text-levi-subtle outline-none transition-colors resize-none"
              />
            </label>

            <div className="mt-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
              <p className="text-xs text-levi-subtle font-mono">
                By submitting you agree to our <a href="/privacy-policy" className="underline hover:text-levi-text">Privacy Policy</a>.
              </p>
              <button type="submit" className="btn-primary" disabled={status === "sending"}>
                {status === "sending" ? "Sending…" : status === "sent" ? "Sent" : "Send message"}
                <Send size={14} />
              </button>
            </div>
          </form>
        </Reveal>
      </div>
    </section>
  );
}

export default Contact;
